import React, { Component } from 'react';
import { PropTypes } from 'prop-types';
import { StyleSheet, css } from 'aphrodite';
import Modal from 'react-modal';
import Isvg from 'react-inlinesvg';
import { Theme } from '../../config/theme';
import TextField from '../TextField';
import Button from '../Button';

const CLOSE_ICON = require('./close.svg');
const STAR_ICON = require('./star.svg');

export default class ReviewModal extends Component {
  constructor(props) {
    super(props);

    this.openHandler = this.props.openHandler;
    this.submitReview = this.props.submitReviewHandler;
    this.setValue = this.props.updateTextField;
    this.setRating = this.props.setRatingHandler;
  }

  render() {
    return (
      <Modal
        isOpen={this.props.open}
        className={css(styles.container)}
        style={{
          overlay: {
            backgroundColor: 'rgba(0,0,0,0.67)',
            zIndex: 10,
            display: 'flex',
          },
        }}
        contentLabel="Review"
      >
        <div className={css(styles.modal_wrapper)}>
          <div className={css(styles.header)}>
            <h2 className={css(styles.title)}>
              {
                this.props.reviewSubmitted === true ?
                  (<span> Review submitted</span>) : (<span> Review this member</span>)
              }
            </h2>
            <div
              className={css(styles.close_icon)}
              onClick={this.props.openHandler}
              role="button"
              tabIndex={0}
            >
              <img src={CLOSE_ICON} alt="Close modal" />
            </div>
          </div>
          {
            this.props.reviewSubmitted === true ?
              (
                <div className={css(styles.body)}>
                  <p className={css(styles.successParagraph)}>
                    Thank you for your feedback. Your review has been published.
                  </p>

                  <Button
                    title="Continue"
                    theme="blue"
                    handler={this.openHandler}
                    styles={styles.full_width_button} />
                </div>
              ) :
              (
                <div className={css(styles.body)}>
                  <p className={css(styles.paragraph)}>
                    Add your rating (only Dog Share Collective will see this rating):
                  </p>
                  <div className={css(styles.stars)}>
                    <div
                      role="button"
                      tabIndex={-4}
                      onClick={() => { this.setRating(1); }}
                      className={css(styles.star, this.props.updatedStars
                      > 0 ? styles.star_active : null)}
                    >
                      <p className={css(styles.ratingBelowStandardText)}>
                        Below standard
                      </p>
                      <Isvg
                        cacheGetRequests
                        src={STAR_ICON}
                      />
                    </div>
                    <div
                      role="button"
                      tabIndex={-3}
                      onClick={() => { this.setRating(2); }}
                      className={css(styles.star, this.props.updatedStars
                      > 1 ? styles.star_active : null)}
                    >
                      <Isvg
                        cacheGetRequests
                        src={STAR_ICON}
                      />
                    </div>
                    <div
                      role="button"
                      tabIndex={-2}
                      onClick={() => { this.setRating(3); }}
                      className={css(styles.star, this.props.updatedStars
                      > 2 ? styles.star_active : null)}
                    >
                      <Isvg
                        cacheGetRequests
                        src={STAR_ICON}
                      />
                    </div>
                    <div
                      role="button"
                      tabIndex={-1}
                      onClick={() => { this.setRating(4); }}
                      className={css(styles.star, this.props.updatedStars
                      > 3 ? styles.star_active : null)}
                    >
                      <Isvg
                        cacheGetRequests
                        src={STAR_ICON}
                      />
                    </div>
                    <div
                      role="button"
                      tabIndex={0}
                      onClick={() => { this.setRating(5); }}
                      className={css(styles.star, this.props.updatedStars
                      > 4 ? styles.star_active : null)}
                    >
                      <p className={css(styles.ratingAboveStandardText)}>
                        Above standard
                      </p>
                      <Isvg
                        cacheGetRequests
                        src={STAR_ICON}
                      />
                    </div>
                  </div>
                  <div className={css(styles.comments)}>
                    <TextField
                      textArea
                      name="public_review"
                      styles={styles.textArea}
                      handler={this.setValue}
                      placeholder="Public comments (optional)"
                      error={this.props.formError}
                    />
                  </div>
                  {
                    this.props.formError ? (
                      <Button
                        title="Submit Review"
                        theme="disabled"
                        disabled={true} //eslint-disable-line
                        styles={styles.full_width_button} />
                    ) : false
                  }
                  {
                    !this.props.formError ? (
                      <Button
                        title="Submit Review"
                        theme="blue"
                        handler={this.submitReview}
                        styles={styles.full_width_button} />
                    ) : false
                  }
                </div>
              )
          }
        </div>
      </Modal>
    );
  }
}

ReviewModal.propTypes = {
  open: PropTypes.bool,
  reviewSubmitted: PropTypes.bool.isRequired,
  openHandler: PropTypes.func.isRequired,
  submitReviewHandler: PropTypes.func.isRequired,
  updateTextField: PropTypes.func.isRequired,
  setRatingHandler: PropTypes.func.isRequired,
  updatedStars: PropTypes.string.isRequired,
  formError: PropTypes.string.isRequired,
};

ReviewModal.defaultProps = {
  open: false,
};


const openModalKeyFrames = {
  from: {
    transform: 'scale(0.8)',
    animationTimingFunction: 'ease-in',
  },

  to: {
    transform: 'scale(1)',
    animationTimingFunction: 'ease-in',
  },
};

const styles = StyleSheet.create({
  container: {
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    width: 590,
    maxWidth: '100vw',
    height: 513,
    maxHeight: '100vh',
    backgroundColor: Theme.white,
    borderRadius: 5,
    overflow: 'hidden',
    outline: 'none',
    margin: 'auto auto',
    animationName: openModalKeyFrames,
    animationDuration: '100ms',
    animationDirection: 'alternate',
  },
  modal_wrapper: {
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    height: 600 - 100,
    width: '100%',
    boxSizing: 'border-box',
    padding: '0px 80px',
  },
  header: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '50px 0px 35px',
  },
  title: {
    marginBottom: 0,
    fontFamily: Theme.font_family_heading,
    fontSize: 30,
    fontWeight: '900',
  },
  close_icon: {
    position: 'absolute',
    right: 15,
    top: 15,
    outline: 'none',
    cursor: 'pointer',
    transition: 'opacity 180ms ease-in-out',
    ':hover': {
      opacity: 0.6,
    },
  },
  body: {
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: '100%',
    textAlign: 'center',
  },
  stars: {
    display: 'flex',
    marginBottom: 40,
  },
  star: {
    display: 'block',
    height: 30,
    width: 30,
    margin: '0 8px',
    stroke: '#DFDFDF',
    fill: '#F4F4F4',
    transition: 'all 300ms',
    cursor: 'pointer',
    outline: 'none',
  },
  star_active: {
    stroke: '#39b4d6',
    fill: '#39b4d6',
  },
  textArea: {
    display: 'flex',
    flexDirection: 'column',
    height: 130,
    width: 337,
    marginBottom: 25,

    ':not(.a) > *': {
      flexGrow: 1,
    },
  },
  paragraph: {
    marginBottom: 20,
    fontFamily: Theme.font_family_primary,
    fontSize: 14,
    color: '#828282',
  },
  ratingBelowStandardText: {
    position: 'absolute',
    marginLeft: -90,
    paddingTop: 10,
    marginBottom: 20,
    fontFamily: Theme.font_family_primary,
    fontSize: 11,
    color: '#828282',
  },
  ratingAboveStandardText: {
    position: 'absolute',
    marginLeft: 45,
    paddingTop: 10,
    marginBottom: 20,
    fontFamily: Theme.font_family_primary,
    fontSize: 11,
    color: '#828282',
  },
  successParagraph: {
    marginBottom: 60,
    fontFamily: Theme.font_family_primary,
    fontSize: 16,
    lineHeight: 1.5,
    color: '#828282',
  },
  actions_container: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
  },
  sign_up_container: {
    fontFamily: Theme.font_family_primary,
    fontSize: 16,
  },
  sign_up_link: {
    display: 'inline',
    fontFamily: Theme.font_family_secondary,
    letterSpacing: 1,
    marginLeft: 5,
    textTransform: 'uppercase',
    fontWeight: 'bold',
  },
  forgotten_password: {
    flex: 1,
    fontFamily: Theme.font_family_primary,
    fontSize: 14,
  },
  login_button_container: {
    flex: 1,
  },
});



// WEBPACK FOOTER //
// ./src/components/ReviewModal/index.js